const tabItems = document.querySelectorAll('.tabs li, .inline-tab');
const tabs = document.querySelectorAll('.tab');

const handleTabItemClick = (e) => {
  for (var i = 0; i < tabItems.length; i++) {
    if (!e.currentTarget.classList.contains('inline-tab')) {
      tabItems[i].classList.remove('is-active');
    }
  }

  for (var i = 0; i < tabs.length; i++) {
    tabs[i].classList.toggle(
      'is-active',
      tabs[i].dataset.key == e.currentTarget.dataset.key
    );
  }

  e.currentTarget.classList.add('is-active');
}

for (var i = 0; i < tabItems.length; i++) {
  tabItems[i].addEventListener('click', handleTabItemClick);
}
